import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { Button, Checkbox, IconButton } from "rsuite";
import { LoadingContext } from "../contexts/LoadingContext";
import { SearchContext } from "../contexts/SearchContext";
import { getUsers } from "../services/user/UserApi";
import { errorToast } from "../utils/helper-ui";
import { PaginationResponse } from "../objects/pagination";
import { getPagination, noImage } from "../utils/helper";
import { User } from "../models/auth/user";
import { Table, Pagination } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import { BsEye, BsTrash3 } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Role } from "../models/system/role";
import Moment from "react-moment";
const { Column, HeaderCell, Cell } = Table;
interface UserPageProps {}

const UserPage: FC<UserPageProps> = ({}) => {
  const nav = useNavigate();
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [users, setUsers] = useState<User[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === users.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < users.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? users.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getUsers({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setUsers((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  //   const removeUser = async (user: User) => {
  //     try {
  //       setIsLoading(true);
  //       if (
  //         window.confirm(
  //           `Are you sure you want to delete user with name ${user.name}?`
  //         )
  //       ) {
  //         await deleteUser(user.id!);
  //         fetchData();
  //       }
  //     } catch (error) {
  //       errorToast(`${error}`);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  //   const saveUser = async (user: User) => {
  //     try {
  //       setIsLoading(true);
  //       if (selectedUser) {
  //         await updateUser(selectedUser.id!, user);
  //       } else {
  //         await createUser(user);
  //       }
  //       setModalFormOpen(false);
  //       setSelectedUser(undefined);
  //       fetchData();
  //     } catch (error) {
  //       errorToast(`${error}`);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">User</h1>
      {/* button */}
      <div>
        {/* <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create User
        </IconButton> */}
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border bg-gray-50 w-32">
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Avatar</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Email</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Role</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Verified
              </th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, i) => (
              <tr key={user.id}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={user.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === user.id)}
                  />
                  {i + 1}
                </td>
                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer font-semibold "
                    onClick={() => {
                      // setSelectedCompany(user as Company);
                      // setModalFormOpen(true);
                    }}
                  >
                    {user.full_name}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                  {user.profile_picture?.url && (
                    <img
                      onError={noImage}
                      src={user.profile_picture?.url}
                      alt={user.full_name}
                      className="w-10 h-10 rounded-full"
                    />
                  )}
                </td>
                <td className="px-4 py-2 border">{user.email}</td>
                <td className="px-4 py-2 border">
                  {/* { user.roles && (
                <div>
                  {user.roles.map((role: Role) => role.name).join(", ")}
                </div>
              )} */}
                </td>
                <td className="px-4 py-2 border">
                  {user.verified_at && (
                    <Moment format="DD-MM-YYYY">{user.verified_at}</Moment>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={users} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size + users.indexOf(rowData as User) + 1}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  //  setSelectedUser(rowData as User);
                  //  setModalFormOpen(true);
                }}
              >
                {rowData.full_name}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Avatar</HeaderCell>
          <Cell style={{ padding: 2 }}>
            {(rowData) =>
              rowData.profile_picture && (
                <div>
                  <img
                    src={rowData.profile_picture.url}
                    alt="avatar"
                    className="w-10 h-10 rounded-full"
                  />
                </div>
              )
            }
          </Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Email</HeaderCell>
          <Cell dataKey="email" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Role</HeaderCell>
          <Cell>
            {(rowData) =>
              rowData.roles && (
                <div>
                  {rowData.roles.map((role: Role) => role.name).join(", ")}
                </div>
              )
            }
          </Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Verified At</HeaderCell>
          <Cell>
            {(rowData) => (
              <Moment format="DD MMM YYYY, HH:mm">{rowData.verified_at}</Moment>
            )}
          </Cell>
        </Column>
      </Table> */}
      {/* <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
    </MainLayout>
  );
};
export default UserPage;
